/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=3b367a9e&scoped=true"
import script from "./newIndex.vue?vue&type=script&lang=js"
export * from "./newIndex.vue?vue&type=script&lang=js"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=3b367a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b367a9e",
  null
  
)

export default component.exports